import ParticipantView from "./ParticipantView";

const ParticipantGrid = ({ participantIds, triggerWebcam, transactionId, setFormData }) => {
  // Determine Bootstrap column size based on number of participants
  const getColClass = (count) => {
    if (count === 1) return 'col-12';
    if (count === 2) return 'col-md-6 col-12';
    if (count <= 4) return 'col-md-6 col-12';
    if (count <= 6) return 'col-lg-4 col-md-6 col-12';
    if (count <= 9) return 'col-lg-4 col-md-6 col-12';
    return 'col-md-3 col-12'; // 4 columns for 10+ participants
  };

  const colClass = getColClass(participantIds.length);

  return (
    <div className="container-fluid h-100">
      <div className="row h-100 w-100 g-2 justify-content-center"  style={{paddingBottom:100}}>
        {participantIds.map((participantId) => (
          <div key={participantId} className={`${colClass} position-relative video-cover p-2`} style={{ maxWidth: 550, minHeight: 325 }} >
            <ParticipantView
              participantId={participantId}
              triggerWebcam={triggerWebcam}
              transactionId={transactionId}
              setFormData={setFormData}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ParticipantGrid;
